






























import { Vue, Component, Emit, Prop } from 'vue-property-decorator';

@Component
export default class DetailModal extends Vue {
  @Prop() data: any;
  @Prop({ default: 'primary' }) type?: any;
  @Emit()
  toggleModal() {
    // console.log('close-btn-clicked');
  }
}
